<div [formGroup]="form">
  <ng-container
    [formGroupName]="i"
    *ngFor="let la of form?.controls; let i = index">
    <div class="la-container-fields">
      <app-input-vocabulary-autocomplete
        formControlName="TCL"
        [vocabularyName]="'V_TLC'"
        [placeholder]="'Tipo di localizzazione (TCL)'">
      </app-input-vocabulary-autocomplete>
      <app-prd-form [form]="form?.controls[i]?.get('PRD')"></app-prd-form>
      <app-prv-form [form]="form?.controls[i]?.get('PRV')"></app-prv-form>
      <button
        *roleVisibility="['create', 'update']; classNames: classNames"
        mat-raised-button
        type="button"
        (click)="removeHandler(i)">
        <mat-icon>delete</mat-icon>
      </button>
    </div>
  </ng-container>
  <button
    *roleVisibility="['create', 'update']; classNames: classNames"
    mat-raised-button
    type="button"
    (click)="addHandler()">
    {{ 'Aggiungi localizzazione' | translate }}
  </button>
</div>
